import { render, staticRenderFns } from "./ShipmentSelect.vue?vue&type=template&id=2c5f0edb&scoped=true"
import script from "./ShipmentSelect.vue?vue&type=script&lang=js"
export * from "./ShipmentSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5f0edb",
  null
  
)

export default component.exports